import React from 'react';
import {Typography, Button, Divider } from '@material-ui/core';
import { Elements, //pre-created stripe elements , encloses the rest, uses stripePromise of loadStripe
         CardElement, //stripe Card element..
         ElementsConsumer //gets {elements, stripe } from stripe
        } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import Review from './Review';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const PaymentForm = ({shippingData, checkoutToken, backStep, nextStep, onCaptureCheckout,timeout }) => {
    const handleSubmit = async (event, elements, stripe) => {
        event.preventDefault(); //so no refresh once button is clicked
        if (!stripe || !elements) return ;
        const cardElement = elements.getElement(CardElement);
        const { error, paymentMethod } = await stripe.createPaymentMethod({ type:'card', card: cardElement});
        if(error){
            console.log("[PaymentForm-handleSubmit-CreatePaymentMethod]got errro : ", error);
        } else {
            const orderData = {
                line_items: checkoutToken.live.line_items,
                customer: { 
                    firstname: shippingData.firstName, 
                    lastname: shippingData.lastName, 
                    email: shippingData.email
                 },
                shipping: { 
                    country: shippingData.shippingCountry,
                    county_state: shippingData.shippingSubdivision, 
                    name: 'International',
                    postal_zip_code: shippingData.zip,
                    street: shippingData.address1, 
                    town_city: shippingData.city, 
                    method: 'test',
                },
                fulfillment: { shipping_method: shippingData.shippingOption },
                payment: {
                    //gateway: 'stripe',
                    //   stripe: {
                    //     payment_method_id: paymentMethod.id,
                    //   },
                gateway: 'test_gateway',
                card: {
                    number: '4242424242424242',
                    expiry_month: '02',
                    expiry_year: '24',
                    cvc: '123',
                    postal_zip_code: '94107',
                },
                },
            } // end orderData
            console.log("[PaymentForm-handleSubmit-CreatePaymentMethod] orderData is : ", orderData);
            onCaptureCheckout(checkoutToken.id, orderData );
            timeout();
            nextStep();
        }
    } // end handleSubmit

    return (
        <>
            <Review checkoutToken={checkoutToken}/>
            <Divider />
            <Typography variant="h6" gutterBottom style={{ margin: '20px 0' }}>Payment method</Typography>
            <Elements stripe={stripePromise}>
                <ElementsConsumer>{({ elements, stripe }) => (
                    <form onSubmit={(e) => handleSubmit(e, elements, stripe)}>
                        <CardElement />
                        <br /> <br />
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Button variant="outlined" onClick={backStep}>Back</Button>
                        <Button type="submit" variant="contained" disabled={!stripe} color="primary">
                            Pay {checkoutToken.live.subtotal.formatted_with_symbol}
                        </Button>
                        </div>
                    </form>
                )}
                </ElementsConsumer>
            </Elements> 
        </>
    )
}

export default PaymentForm;
